<template lang="pug">
  #publication
    section.section
      .container
        .lg
          .title.is-4 Publications
          .btns
            button(@click="move('left')") «
            button(@click="move('right')") »
        .silderContainer
          .column#silder
            .silderContainer
              Col(:m=4 :s=6 :xs=12 v-for="(item, index) in publications" :key="index" style="padding-bottom: 32px")
                Thumb(:paper="item" :isClick="choose[index]" @click.native="showOne(index)")
        .columns#paper(style="padding: 20px 35px")
          .column.is-3
            a(:href="paper.link" target="blank")
              .title.is-4 {{paper.title}}:
              .subtitle.is-6 {{paper.subtitle}}
          .column.is-9.detail
            .content
                span {{cutWords(paper.content)}} ...
                a.more(:href="paper.link" target="blank") more
</template>

<script>

import Thumb from '@/components/Thumb'
import Col from '@/components/Col'
import { publications, paperContent } from '../data/data.json'

export default {
  name: 'Publication',
  components: {
    Thumb,
    Col
  },
  data () {
    return {
      choose: [true, false, false, false, false, false, false],
      publications,
      paperContent,
      pos: 0,
      shiftCount: 0,
      paper: null,
      itemPerRow: null
    }
  },
  beforeMount () {
    this.paper = paperContent[this.publications[0].title]
  },
  mounted () {
    this.getColWidthandShift()
    window.addEventListener('resize', this.move)
  },
  methods: {
    getColWidthandShift () {
      this.itemPerRow = 12 / Number(this.$children[0].columnWidthClass.replace('is-', ''))
      this.shiftCount = Math.ceil(publications.length / this.itemPerRow)
    },
    showOne (index) {
      this.choose = this.choose.map(el => false)
      this.choose[index] = true
      this.paper = paperContent[this.publications[index].title]
    },
    move (direction = 'none') {
      this.getColWidthandShift()
      const columns = document.querySelector('#silder .silderContainer')
      switch (direction) {
        case 'right':
          this.pos = Math.min(this.pos + 1, this.shiftCount - 1)
          break
        case 'left':
          this.pos = Math.max(this.pos - 1, 0)
          break
        default:
          this.pos = Math.min(this.pos, this.shiftCount - 1)
      }
      this.showOne(this.pos * this.itemPerRow)
      columns.style.transform = 'translateX(' + (-this.pos * columns.offsetWidth) + 'px)'
    },
    cutWords (text) {
      const maxLength = 410
      const trimmedString = text.substr(0, maxLength)
      return trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(' ')))
    }
  }
}
</script>

<style lang="sass" scoped>

section.section
  padding: 0 1.5rem

#publication
  padding-top: 10vh
  background: linear-gradient(#ddd, #e8e8e8)

.container
  min-height: 30vh
  padding-bottom: 60px
  .lg
    display: flex
    justify-content: space-between
    align-items: center
    .btns
      margin-right: 24px

#silder
  overflow: hidden
  padding: 0
  .silderContainer
    transition: transform .7s ease-in-out
    transform: translateX(0px)
    .column.is-12
      flex: none
      width: 100%

#paper
  line-height: 1.7
  .more
    background-color: #e8e8e8
    color: #333
    border: 1px solid #333
    box-sizing: border-box
    border-radius: 2px
    cursor: pointer
    padding: 0px 8px 3px 8px
    margin-left: .3em
    transition: .3s
    &:hover
      background-color: #333
      color: white

.silderContainer
  display: flex
  flex-direction: row

button
  *
    background: transparent
  width: 1em
  padding: 0
  border: none
  background: transparent
  color: #222
  font-size: 40px
  text-align: center
  outline: none
  opacity: 0.5
  -webkit-transition: opacity 300ms ease-out
  transition: opacity 300ms ease-out
  cursor: pointer
  &:hover
    opacity: 1
  &:active
    background: transparent

@media screen and (max-width: 436px)
  .container .lg .btns
    margin-right: 0
  #paper
    padding-left: 0 !important
    padding-right: 0 !important
    .detail
      display: none !important

</style>



// WEBPACK FOOTER //
// src/section/Publication.vue